<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <div
              v-if="isLoading"
              class="tw-flex tw-items-center tw-justify-center tw-min-h-80"
          >
            <v-progress-circular
                color="primary"
                indeterminate
            ></v-progress-circular>
          </div>
          <v-card-text v-else-if="!selectedCompany.isDemo && companyProductList.isNsThaiSmartTax && !isLoading">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                    :disabled="item.disabled"
                    :exact="true"
                    :to="item.to"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="tw-flex tw-justify-between">
              <div
                  class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide"
              >
                ตั้งค่า WithHolding Tax
              </div>
              <v-btn
                  color="primary"
                  large
                  outlined
                  @click="isEditing = !isEditing"
                  v-if="!isEditing"

              >
                <v-icon left>mdi-pencil</v-icon>
                แก้ไข
              </v-btn>


            </div>
            <div class="tw-mx-5">
              <v-form>
                <v-row>
                  <v-col cols="12">
<!--                    <v-checkbox-->
<!--                        v-model="withholdingTax.enabledArWhtValidation"-->
<!--                        class="tw-m-0 tw-pt-3"-->
<!--                        dense-->
<!--                        label="เปิดใช้งานการตรวจสอบภาษีหัก ณ ที่จ่าย A/R"-->
<!--                        :readonly="!isEditing"-->
<!--                    ></v-checkbox>-->

                    <v-responsive max-width="800" class="tw-pt-2">

                      <v-text-field
                          v-model="withholdingTax.whtCertificatePrintCopies"
                          class="tw-m-0 tw-pt-1"
                          dense
                          label="จำนวนสำเนาของหนังสือรับรองการหักภาษี ณ ที่จ่าย"
                          min="1"
                          outlined
                          type="number"
                          :readonly="!isEditing"
                      ></v-text-field>
                    </v-responsive>

<!--                    <v-checkbox-->
<!--                        v-model="withholdingTax.showEntityBranch"-->
<!--                        class="tw-m-0 tw-pt-0"-->
<!--                        dense-->
<!--                        label="แสดงสาขานิติบุคคลในใบรับรองการหักภาษี ณ ที่จ่าย"-->
<!--                        :readonly="!isEditing"-->
<!--                    ></v-checkbox>-->

<!--                    <v-checkbox-->
<!--                        v-model="withholdingTax.enabledAutoGenerateWhtCertNo"-->
<!--                        class="tw-m-0 tw-pt-0"-->
<!--                        dense-->
<!--                        label="เปิดใช้งานการสร้างหมายเลขใบรับรองการหักภาษีอัตโนมัติ"-->
<!--                        :readonly="!isEditing"-->
<!--                    ></v-checkbox>-->

                    <v-responsive max-width="800" class="tw-pt-1">
                      <v-text-field
                          v-model="withholdingTax.certificateNumberFormat"
                          class="tw-m-0 tw-pt-1"
                          dense
                          label="รูปแบบหมายเลขใบรับรองการหักภาษี"
                          outlined
                          placeholder=""
                          :disabled="disableCertificateNumberFormat"
                          :readonly="!isEditing"
                      ></v-text-field>
                    </v-responsive>
                    <v-simple-table class="elevation-1 tw-w-1/2">
                      <thead class="tw-bg-light-gray">
                      <tr>
                        <th>คำอธิบาย</th>
                        <th>ID</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in formatDescription" :key="item.id">
                        <td>{{ item.description }}</td>
                        <td>{{ item.id }}</td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
<!--                    <v-checkbox-->
<!--                        v-model="withholdingTax.includeDeclinedPayments"-->
<!--                        class="tw-m-0 tw-pt-0"-->
<!--                        dense-->
<!--                        label="รวมบิลที่ถูกปฏิเสธและการชำระเงินที่ถูกปฏิเสธในรายงานภาษีหัก ณ ที่จ่าย"-->
<!--                        :readonly="!isEditing"-->
<!--                    ></v-checkbox>-->
                  </v-col>
                </v-row>
                <v-divider></v-divider>

                <h2 class="tw-py-4 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">การตั้งค่าลายเซ็น</h2>
                <v-row>
                  <v-col cols="5">
                    <!-- Full Name Input -->
                    <v-text-field
                        v-model="signatureSetup.fullName"
                        class="tw-mb-2"
                        dense
                        label="ชื่อ-นามสกุล"
                        outlined
                        :rules="[rules.required, rules.minLength]"
                        :disabled="!isEditing"
                    ></v-text-field>

                    <!-- Signature File Upload -->
                    <template
                        v-if="isEditing"
                    >

                    <v-file-input
                        v-model="signatureSetup.signatureImage"
                        class="tw-mb-2"
                        dense
                        label="รูปภาพลายเซ็น"
                        outlined
                        accept="image/png, image/jpeg"
                        @change="cropAndResizeImage"
                        :rules="[rules.required, rules.fileSize, rules.fileType]"
                        hide-details="auto"
                        :readonly="!isEditing"
                    ></v-file-input>

                    <span class="tw-text-caption tw-text-sm">
                          ไฟล์ควรอยู่ในรูปแบบ PNG หรือ JPEG ขนาดน้อยกว่า 5MB
                        </span>
                    </template>

                    <!-- Image Preview -->
                    <span class="tw-text-caption tw-text-sm" v-if="!isEditing">
                      ลายเซ็นปัจจุบัน
                    </span>
                    <v-img
                        v-if="signaturePreview"
                        :src="signaturePreview"
                        class="tw-mt-2 tw-border tw-border-gray-500-300"
                        contain
                        max-width="200px"
                        :readonly="!isEditing"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>
                <div class="tw-flex tw-justify-end">
                  <div class="tw-flex tw-gap-2">
                    <v-btn
                        color="primary"
                        large
                        outlined
                        @click="isEditing = !isEditing"
                        v-if="isEditing"
                    >
                      <v-icon left>mdi-close</v-icon>
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        :loading="isSaving"
                        color="primary"
                        large
                        @click="save"
                        v-if="isEditing"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      บันทึก
                    </v-btn>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <div
              v-else
              class="align-center justify-center"
              style="height: 200px; display: flex"
          >
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
    <v-snackbar v-model="saveSuccess" color="primary" top>
      บันทึกข้อมูลสำเร็จ
    </v-snackbar>
    <v-snackbar v-model="snackbarError" color="error" top timeout="4000">
      {{ snackbarErrorMsg }}
    </v-snackbar>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import {mapState} from "vuex";
import fc from "@/firebaseConfig";

export default {
  name: "Settings",
  components: {
    Admin
  },
  data: () => ({
    isLoading: false,
    isSaving: false,
    saveSuccess: false,
    snackbarError: false,
    snackbarErrorMsg: '',
    disableCertificateNumberFormat: true,
    withholdingTax: {
      enabledArWhtValidation: false,
      whtCertificatePrintCopies: 0,
      showEntityBranch: false,
      enabledAutoGenerateWhtCertNo: false,
      certificateNumberFormat: '${SUBSIDIARY_BRANCH}${WHT_CATEGORY}${YYYY}${MM}${DD}${NNNN}',
      includeDeclinedPayments: false,
    },
    inputRules: {
      certificateNumberFormat: [
        (v) => {

        },
      ],
    },
    formatDescription: [
      {description: 'ปี (4 หลัก)', id: '${YYYY}'},
      {description: 'ปี (2 หลัก)', id: '${YY}'},
      {description: 'เดือน (2 หลัก)', id: '${MM}'},
      {description: 'วัน (2 หลัก)', id: '${DD}'},
      {description: 'สาขาย่อย', id: '${SUBSIDIARY_BRANCH}'},
      {description: 'Withholding Tax Category', id: '${WHT_CATEGORY}'},
      {description: 'Running Number (4 หลัก)', id: '${NNNN}'},
    ],

    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: {name: "Company.Settings"},
      },
      {
        text: "ตั้งค่า WithHolding Tax",
        disabled: true,
      },
    ],
    unsub: null,

    signatureSetup: {
      fullName: '',
      signatureImage: null,
      signatureUrl: "",
    },
    signaturePreview: null,
    rules: {
      required: v => !!v || 'This field is required',
      minLength: v => (v && v.length >= 3) || 'Minimum 3 characters',
      fileSize: file => {
        return file && file.size < 5000000 || 'File size must be less than 2MB';
      },
      fileType: file => {
        const allowedTypes = ['image/png', 'image/jpeg'];
        return file && allowedTypes.includes(file.type) || 'Only PNG and JPG allowed';
      },
    },
    isEditing: false,
  }),
  computed: mapState({
    companyId: (state) => state.companies.selectedCompany.companyId,
    selectedCompany: (state) => state.companies.selectedCompany,
    companyProductList: state => state.companies.selectedCompanyProductList,
  }),
  watch: {
    companyProductList: {
      handler() {
        if (this.companyProductList.isNsThaiSmartTax) {
          this.listenToTaxRunningSettingAndSignatureSetting()
        }
      },
      immediate: true
    },
    isEditing: {
      handler() {
        if (!this.isEditing) {
          this.listenToTaxRunningSettingAndSignatureSetting()
        }
      }
    }
  },
  methods: {
    listenToTaxRunningSettingAndSignatureSetting() {
      const companyId = this.$router.currentRoute.params.companyId;
      const settingPath = "SettingThaiSmartTax/taxRunningSetting";
      const settingDoc = fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxRunningSetting");

      if (this.unsub) this.unsub();
      this.isLoading = true
      this.unsub = (settingDoc.onSnapshot(async snapshot => {
        const data = snapshot.data();
        if (snapshot.exists && Object.keys(data).length > 3) {
          this.withholdingTax = data;
        } else {
          await this.save();
        }
        this.isLoading = false
      }, (e) => {
        console.error(`${companyId}/${settingPath}`, e)
        this.isLoading = false
      }))

      const docAmount = fc.companies.doc(companyId).collection('DocsThaiSmartTax').limit(1)
      docAmount.get().then((snapshot) => {
        console.log(snapshot.size)
        this.disableCertificateNumberFormat = snapshot.size !== 0;
      })

      const signatureDoc = fc.db.doc(`/Companies/${companyId}/SettingThaiSmartTax/signature`)
      signatureDoc.get().then((snapshot) => {
        const data = snapshot.data();
        if (snapshot.exists && data) {
          this.signatureSetup.fullName = data.name;
          this.signaturePreview = data.signature_url;
        }
      })
    },
    async save() {
      this.isSaving = true
      try {
        const taxRunningSetting = {
          ...this.withholdingTax,
          certificateNumberFormat: this.withholdingTax.certificateNumberFormat.toUpperCase(),
          whtCertificatePrintCopies: parseInt(this.withholdingTax.whtCertificatePrintCopies) || 0,
        }
        await this.$store.dispatch('thaismartTaxDetail/saveSignatureSetting', {
          companyId: this.companyId,
          taxRunningSetting,
          fullName: this.signatureSetup.fullName,
          dataUrl: this.signaturePreview,
          hasNewImage: !!this.signatureSetup.signatureImage,
        })
        this.saveSuccess = true
      } catch (err) {
        console.error('save() failed:', err)
        this.snackbarErrorMsg = `บันทึกไม่สำเร็จ: ${(err && err.message) || err}`
        this.snackbarError = true
      } finally {
        this.isSaving = false
        this.isEditing = false
      }
    },
    cropAndResizeImage(file) {
      if (!file) {
        this.signaturePreview = null;
        return;
      }

      const allowedTypes = ['image/png', 'image/jpeg'];
      if (!allowedTypes.includes(file.type)) {
        alert('Only PNG and JPG files are allowed.');
        this.signatureSetup.signatureImage = null;
        this.signaturePreview = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        this.signaturePreview = e.target.result;
      };

      reader.readAsDataURL(file);
/*      if (!file) {
        this.signaturePreview = null;
        return;
      }

      const allowedTypes = ['image/png', 'image/jpeg'];
      if (!allowedTypes.includes(file.type)) {
        alert('Only PNG and JPG files are allowed.');
        this.signatureSetup.signatureImage = null;
        this.signaturePreview = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const targetAspectRatio = 8 / 2; // Change this for other aspect ratios
          const targetWidth = 800;
          const targetHeight = 200;

          let srcWidth = img.width;
          let srcHeight = img.height;
          let srcX = 0, srcY = 0;

          // Calculate the best crop dimensions
          if (srcWidth / srcHeight > targetAspectRatio) {
            // Image is too wide, crop horizontally
            const newWidth = srcHeight * targetAspectRatio;
            srcX = (srcWidth - newWidth) / 2;
            srcWidth = newWidth;
          } else {
            // Image is too tall, crop vertically
            const newHeight = srcWidth / targetAspectRatio;
            srcY = (srcHeight - newHeight) / 2;
            srcHeight = newHeight;
          }

          // Create canvas and draw the cropped & resized image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = targetWidth;
          canvas.height = targetHeight;

          ctx.drawImage(img, srcX, srcY, srcWidth, srcHeight, 0, 0, targetWidth, targetHeight);

          // Convert canvas to Base64 format
          this.signaturePreview = canvas.toDataURL(file.type);
        };
      };

      reader.readAsDataURL(file);*/
    },
  },
  async mounted() {

  },
  beforeDestroy() {
    if (this.unsub) this.unsub();
  }
};
</script>
<style lang="scss">
.row-wrapper {
  padding-left: 20px;
}
</style>
